import { Heading, HStack, ModalHeader } from '@chakra-ui/react';
import React from 'react';
import StandardModalCloseButton from './StandardModalCloseButton';
import { localise } from '../../../services/lang/lang';
const StandardModalHeader = ({ title, testId, closeLabel, closeButtonTestId, }) => (React.createElement(ModalHeader, { "data-testid": "standard_modal_header" },
    React.createElement(HStack, { w: "100%" },
        React.createElement(Heading, { as: "h2", tabIndex: -1, variant: "md-600-lt-4", "data-testid": testId ?? 'standard_modal_header__title', m: 0, "aria-label": title }, title),
        React.createElement(StandardModalCloseButton, { testId: closeButtonTestId, label: closeLabel ?? localise('CLOSE') }))));
export default StandardModalHeader;
